import { TodoFilterState } from "features/TodoOploggSidebar/Todo/todoFilter/useTodoFilterState";
import { UserRole } from "shared/types/roles";
import { isNotNullish } from "shared/utils/objectUtils";

export const getLocalStorageRole = () =>
  localStorage.getItem("user_role") as UserRole;

export const setLocalStorageRole = (userRole: UserRole) =>
  localStorage.setItem("user_role", userRole);

export const setLocalStorageTodoFilterSettings = (
  todoFilterSettings: TodoFilterState,
) =>
  localStorage.setItem(
    "todoFilterSettings",
    JSON.stringify(todoFilterSettings),
  );

export const getLocalStorageTodoFilterSettings = (): TodoFilterState =>
  JSON.parse(localStorage.getItem("todoFilterSettings") ?? "null");

export const setLocalStorageOploggTodoTabsSettings = (
  oploggTodoTabSettings: string[],
) =>
  localStorage.setItem(
    "oploggTodoTabsSettings",
    JSON.stringify(oploggTodoTabSettings),
  );

export const getLocalStorageOploggTodoTabsSettings = (): string[] =>
  JSON.parse(
    localStorage.getItem("oploggTodoTabsSettings") ??
      JSON.stringify(["oplogg"]),
  );

export const setLocalStorageVehicleAffectedSidePanelSettings = (
  VehicleAffectedSidePanelSettings: boolean,
) =>
  localStorage.setItem(
    "VehicleAffectedSidePanelSettings",
    JSON.stringify(VehicleAffectedSidePanelSettings),
  );

export const getLocalStorageVehicleAffectedSidePanelSettings = (): boolean =>
  JSON.parse(
    localStorage.getItem("VehicleAffectedSidePanelSettings") ??
      JSON.stringify(true),
  );

function keyForMeasureProgressRushState(incidentId: string): string {
  return `measureProgress:isRush:${incidentId}`;
}

export function setLocalStorageMeasureProgressRushState(
  incidentId: string,
  value: boolean,
): void {
  localStorage.setItem(
    keyForMeasureProgressRushState(incidentId),
    JSON.stringify(value),
  );
}

export function getLocalStorageMeasureProgressRushState(
  incidentId: string,
): boolean {
  const storedValue = localStorage.getItem(
    keyForMeasureProgressRushState(incidentId),
  );

  if (isNotNullish(storedValue)) {
    return JSON.parse(storedValue);
  }

  return false;
}

const keyForMeasureCardMuteHistory = (uuid: string) => `muteHistory:${uuid}`;

export type MuteHistoryEntry = {
  timestamp: string;
  action: "muted" | "unmuted";
  reason?: string;
};

export function getLocalStorageMeasureCardMuteHistory(
  uuid: string,
): MuteHistoryEntry[] {
  const storedValue = localStorage.getItem(keyForMeasureCardMuteHistory(uuid));

  if (isNotNullish(storedValue)) {
    const parsedValue = JSON.parse(storedValue);

    if (Array.isArray(parsedValue)) return parsedValue as MuteHistoryEntry[];
  }

  return [];
}

export function setLocalStorageMeasureCardMuteHistory(
  uuid: string,
  muteHistory: MuteHistoryEntry[],
) {
  localStorage.setItem(
    keyForMeasureCardMuteHistory(uuid),
    JSON.stringify(muteHistory),
  );
}

const keyForMeasureCardLastAcknowledgedVersion = (uuid: string) =>
  `lastAcknowledgedUpdate:${uuid}`;

export function getLocalStorageMeasureCardLastAcknowledgedVersion(
  uuid: string,
): number {
  const value = localStorage.getItem(
    keyForMeasureCardLastAcknowledgedVersion(uuid),
  );

  return parseInt(value ?? "0", 10);
}

export function setLocalStorageMeasureCardLastAcknowledgedVersion(
  uuid: string,
  version: number,
) {
  localStorage.setItem(
    keyForMeasureCardLastAcknowledgedVersion(uuid),
    version.toString(),
  );
}
